import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'; // Import useDispatch
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import JobSiteCard from '../components/JobSiteCard';
import { MdOutlineDomainAdd } from "react-icons/md";
import { FaSearch } from "react-icons/fa";
import { useSubStatus } from '../hooks/useSubStatus'; // Import the subscription hook
import { getJobsites } from '../features/jobsites/jobsitesSlice'; // Import Redux action

const JobSites = () => {
    const dispatch = useDispatch(); // Initialize dispatch
    
    const { jobsites , isLoading, message, isSuccess} = useSelector(state => state.businessJobsites); // Provide a default value for jobsites
    

    const [searchQuery, setSearchQuery] = useState('');
    const { canAccessFeatures, hasSubscription, subStatus } = useSubStatus();

    const handleNewJobSiteClick = (e) => {
        if (!canAccessFeatures) {
            e.preventDefault();
            toast.error("No active subscription");
        } else if (subStatus === "trialing") {
            toast.info("Reminder: You are on a trial. Please add a payment method soon to avoid interruption.");
        }
    };

    // Fetch job sites when the component mounts
    useEffect(() => {
        dispatch(getJobsites()); 
    }, [dispatch]);

    // Refetch jobsites after a successful delete
    useEffect(() => {
        if (isSuccess && message === "Jobsite deleted successfully") {
        dispatch(getJobsites());
        }
    }, [isSuccess, message, dispatch]);

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const filteredJobSites = jobsites?.filter(jobSite =>
        jobSite.jobsiteName.toLowerCase().includes(searchQuery.toLowerCase()) ||
        jobSite.address.toLowerCase().includes(searchQuery.toLowerCase())
    );

    return (
        <>
            <div className="container relative flex items-center border-b-2 p-4">
                {/* Search */}
                <div className="flex-1 flex justify-center mt-1">
                    <div className="relative w-full max-w-md">
                        <input
                            type="text"
                            placeholder="Search"
                            value={searchQuery}
                            onChange={handleSearch}
                            className="w-full p-2 pl-10 border border-blue-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                        <FaSearch className="absolute left-3 top-3 text-gray-400" />
                    </div>
                </div>
                {/* Add Job Site Button */}
                <div className="hidden lg:block absolute right-0">
                    <button className="flex items-center gap-2 p-2 rounded-md relative group bg-orangem hover:bg-orange-500 transition-colors duration-300 shadow-lg">
                        <Link
                            to="/newJobSite"
                            onClick={handleNewJobSiteClick}
                            className="flex flex-col items-center gap-2 sm:flex-row"
                        >
                            <MdOutlineDomainAdd className="text-black hidden sm:block text-2xl sm:text-lg" />
                            <span className="font-sans font-medium text-sm sm:text-base">Add Jobsite</span>
                        </Link>
                    </button>
                </div>
                {/* Show button inline on small screens */}
                <div className="lg:hidden ml-4">
                    <button className="flex items-center gap-2 p-2 rounded-md relative group bg-orangem hover:bg-orange-500 transition-colors duration-300 shadow-lg">
                        <Link
                            to="/newJobSite"
                            onClick={handleNewJobSiteClick}
                            className="flex flex-col items-center gap-2 sm:flex-row"
                        >
                            <MdOutlineDomainAdd className="text-black hidden sm:block text-2xl sm:text-lg" />
                            <span className="font-sans font-medium text-sm sm:text-base">Add Jobsite</span>
                        </Link>
                    </button>
                </div>
            </div>

            {/* JobSite List */}
            <div className="p-4">
                {isLoading ? (
                    <p>Loading job sites...</p>
                ) : (
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2">
                        {filteredJobSites?.map((jobSite) => (
                            <div key={jobSite.id} className="p-1 m-1">
                                <JobSiteCard
                                    jobSite={jobSite}
                                />
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </>
    );
}

export default JobSites;